import BaseHeader from '../index';

class Header extends BaseHeader {
  // Overrides original method. Cannot be static.
  // eslint-disable-next-line class-methods-use-this
  getRoutes(_routes) {
    // Deep clone uk routes to be ua routes
    const routes = JSON.parse(JSON.stringify(_routes));

    // For PL the ukrainian language code is overridden to ua
    if (routes.uk) {
      routes.ua = routes.uk;
      delete routes.uk;
    }

    return routes;
  }

  getLinks(_links) {
    // Deep clone uk links to be ua links
    const links = JSON.parse(JSON.stringify(_links));

    // For PL the ukrainian language code is overridden to ua
    if (links?.uk) {
      links.ua = links.uk;
      delete links.uk;
    }

    return super.getLinks(links);
  }
}

export default Header;
